import parseCampusHours from "../util/parseCampusHours";

const CampusHours = ({hours}: {hours: string}) => {
	const parsedHours = parseCampusHours(hours);
	return (
		<div>
			{parsedHours.map((hoursLine: string) => (
				<p key={hoursLine} className="whitespace-pre-line">
					{hoursLine}
				</p>
			))}
		</div>
	);
};

export default CampusHours;
